import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { get } from '../../services/apiController';

const ReactSelect = ({ url, placeholder, isMulti, onChange, value }) => {
  const [data, setData] = useState([]);
  const FetchData = () => {
    get(url)
      .then((res) => {
        setData(res?.data?.rows);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const options = data.map((item) => {
    return {
      value: item?.id,
      label: item?.name,
    };
  });

  useEffect(() => {
    FetchData();
  }, []);

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      isMulti={isMulti}
      isClearable
      isSearchable
      className="basic-multi-select"
      classNamePrefix="select"
      placeholder={placeholder}
      styles={{
        control: (provided, state) => ({
          ...provided,
          minHeight: '55px',
        }),
      }}
    />
  );
};

export default ReactSelect;
